$(document).ready(function(){
  
    var first_option_label = $('label[for=productSelect-option-0]').text();
    var second_option_label = $('label[for=productSelect-option-1]').text();
    var third_option_label = $('label[for=productSelect-option-2]').text();
    var pricing_option = 'none';
  
  

  $('a.image_preview').mouseenter(function(){
    $(this).trigger('click');
  })

    $('input#upload_artwork').change(function () {
    $('#upload').hide();
    $('#uploaded').show();

  });
  
  setTimeout(function(){
    

    
    
    if (first_option_label.toLowerCase().indexOf("pricing") >= 0) {
      pricing_option = '1';
    }
    if (second_option_label.toLowerCase().indexOf("pricing") >= 0) {
      pricing_option = '2';
    }
    if (third_option_label.toLowerCase().indexOf("pricing") >= 0) {
      pricing_option = '3';
    }
      
      
      
      
    
          if ( pricing_option != 'none' ) {

            
                  $('.variant-grid.not_custom_sizes select[data-option=option' + pricing_option +']').change(function(){

                    var value = $(this).val().split('-'),
                    ll = parseInt(value[0]);
                    $('input#Quantity').val(ll);
                    $('#change_qty').hide();
                    $("input#Quantity").trigger('change');

                  });
          }else {
            
            $('.variant-grid.not_custom_sizes select[data-option=option' + pricing_option +']').change(function(){
              
                    $("input#Quantity").trigger('change');
              
            })

            
          }
            
    
                  $("input#Quantity").on("change keyup", function() {
                    
                    
               if (pricing_option != 'none') {

                    
                    var avail = $('#remaining_stock').html(),
                        low_stock = false,
                        max_inv = parseInt(avail),
						qmax = $('select[data-option=option' + pricing_option +']').find('option:selected').val(),
                        n = qmax.indexOf("+"),
                        
                        onlyone = qmax.indexOf("-"),

                        quantitytier = $('select[data-option=option' + pricing_option +']').find('option:selected').val().split('-'),
                        lowlimit = parseInt(quantitytier[0]),
                        highlimit = parseInt(quantitytier[1]),
                        valll = Math.abs(parseInt(this.value, 10) || 1);
                    
                    
                    if (pricing_option != 'none') {
                    }else{
                      lowlimit = 0;
                      highlimit = 99999999;
                      
                    }

                    if ( (onlyone < 0) && (n < 0) ) {lowlimit = 1; highlimit = 1}

                    if (n > -1) {highlimit = 999999999999 }


                    
                    if(isNaN(max_inv)) {
                        $('#change_stock').hide();
                    }else {
                      if (max_inv < highlimit) {
                        highlimit = max_inv;
                        low_stock = true
                      }
                    }
                    
                   
                    
                    if (avail.toLowerCase().indexOf("backorder") >= 0) {
                    }else {
                    
                      if (low_stock == true){
                         $('button#AddToCart').prop('disabled',true).addClass('s_disabled');
                         $('#uom_msg').hide();
                         $('#change_qty').hide();
                         $('#change_stock').show().html(max_inv + ' in stock');
                      }else {
                          $('#change_stock').hide();
                          $('button#AddToCart').removeClass('s_disabled');
                      }
                      
                    }
                    
                 
               }else {
                 
                 var avail = $('#remaining_stock').html(),
                     availa = $('span#availableQty').html(),
                     max_inv = parseInt(avail),
                     quan = $('input#Quantity').val();
                 
                 
                 if (availa.toLowerCase().indexOf("backorder") >= 0) {
                 }else {
                   
                         if (quan > max_inv){
                                 $('button#AddToCart').prop('disabled',true).addClass('s_disabled');
                                 $('#uom_msg').hide();
                                 $('#change_qty').hide();
                                 $('#change_stock').show().addClass('f_show').html(max_inv + ' in stock');                 
                         }else {
                                  $('#change_stock').hide().removeClass('f_show');
                                  $('button#AddToCart').prop('disabled',false).removeClass('s_disabled');
                         }
                   
                 }
                 
                 
               }
                    
                    
                 if (pricing_option != 'none') {

                        if ((valll >= lowlimit) && (valll <= highlimit)){
                          $('button#AddToCart').prop('disabled',false).removeClass('s_disabled');;
                          $('#change_qty').hide().removeClass('f_show').text('Quantity must be within pricing break');
                        }else{
                          $('button#AddToCart').prop('disabled',true).addClass('s_disabled');;
                          if (low_stock == true) {
                           $('#uom_msg').hide().removeClass('f_show').text('Quantity must be within pricing break');

                            if (valll < lowlimit) {
                            $('#change_qty').addClass('f_show').text('Quantity must be within pricing break');
                            }else {
                                 if (valll > highlimit) {
                                     $('#change_qty').addClass('f_show').text('Quantity must not exceed stock ('+max_inv+')');
                                }
                            }


                            $('#change_stock').show().html(max_inv + ' in stock');
                          }else {
                           $('#change_stock').hide();
                           $('#change_qty').show().removeClass('f_show').text('Quantity must be within pricing break');

                          }
                        }

                 }else {
                  $('#change_qty').addClass('n_show');
                   
                 }
                    
                    
                  });

                  $('button.adjust').click(function(){
                    $("input#Quantity").trigger('change');
                  });

                  $("select[data-option=option" + pricing_option + "]").trigger('change');
                  


          
    
  },60)
  

  
                  $('.variant-grid.custom_sizes select[data-option=option' + pricing_option +']').change(function(){
                        

                        var value = $(this).val().split('-'),
                        ll = parseInt(value[0]),
                        hl = parseInt(value[1]),
                        q =  $("input#Quantity").val(),
                        qu =  parseInt(q),
                        n = value.indexOf("+");

                    	if (n > -1) {hl = 999999999999 }

                    
                        if ((qu >= ll) && (qu <= hl)){
                          $('button#AddToCart').prop('disabled',false).removeClass('s_disabled');
                          $('#change_qty').hide();
                        }else {
                          $('button#AddToCart').prop('disabled',true).addClass('s_disabled');
                          $('#change_qty').show();
                        }

                      });
                    
                      //  $(".custom_sizes input").on("blur", function(e) {
                      //     $('#pricing_message').hide()
                      //  })
                      //  $(".custom_sizes input").on("focus", function() {
                      //     $('#pricing_message').show()
                      //  })
                  
                       $(".custom_sizes .input input").on("change keyup", function() {

                        var total_quantity = 0;
                         var pricing_break = $('select[data-name="Pricing Break"] option:selected').attr('data-value')
                         console.log(pricing_break)

                         $(".custom_sizes .input input").each(function(){
                           if ($(this).val() != ''){
                           total_quantity = total_quantity + parseInt($(this).val());
                           }
                         });

                         $("input#Quantity").val(total_quantity).trigger('change');
    
                          if (total_quantity >= pricing_break){
                            $("input#Quantity").removeClass('red')
                            $('button.has_custom_sizes.no_q').removeClass('no_q')
                          }else {
                            $("input#Quantity").addClass('red')
                            $('button.has_custom_sizes').addClass('no_q')
                          }
                         
                          if(parseInt($(this).val()) > 0){
                            $(this).closest('tr').find('.customer-name').show();
                          }else{
                            $(this).closest('tr').find('.customer-name').hide();
                             $(this).closest('tr').find('.customer-name input').val('');
                          }

                       });

                    
                     $('.variant-grid.custom_sizes button#AddToCart').prop('disabled',true).addClass('s_disabled');
                     $(".custom_sizes input:first-child").trigger("change");
  

  
  
})